module.exports = __webpack_public_path__ + "static/media/left.fe372322.webp";